module.exports = __webpack_public_path__ + "39319155a872bad8c533e7a8b3823430.svg";